import { Directive, input } from '@angular/core';

type TableRowTemplateContext<Titem extends object> = {
  $implicit: Titem;
  rowIndex: number;
};

@Directive({
  selector: 'ng-template[cTypedTableRow]',
})
export class TypedTableRowDirective<T extends object> {
  public readonly items = input.required<T[] | null>({
    alias: 'cTypedTableRow',
  });

  public static ngTemplateContextGuard<TContextItem extends object>(
    dir: TypedTableRowDirective<TContextItem>,
    ctx: unknown
  ): ctx is TableRowTemplateContext<TContextItem> {
    return true;
  }
}
